import { FC, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { fetchFormConfiguration } from "../../store/form-slice";
import { useAppDispatch } from "../../store/hooks";

const LoadFormConfiguration: FC<{}> = ({}) => {
  let [queryParams] = useSearchParams();
  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(fetchFormConfiguration(queryParams));
  }, [dispatch, queryParams]);
  return null;
};

export default LoadFormConfiguration;
//LoadFormConfiguration.whyDidYouRender = true;
